import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d58cca0e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d58cca0e')) {
      api.createRecord('d58cca0e', component.options)
    } else {
      api.reload('d58cca0e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d58cca0e&", function () {
      api.rerender('d58cca0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/reportes/servicios_bicevida/index.vue"
export default component.exports